import Moment from 'moment'
import * as Redux from 'redux'
import * as App from '../../app'
import * as DateSelector from '../../components/date-selector'
import * as IsActive from '../../components/is_active'
import * as Sortable from '../../components/sortable'
import * as Request from '../../request'
import * as Router from '../../router'
import * as Constants from './constants'
import * as Types from './types'

const emptyViewState: Types.NewsbriefCountViewState = {
  dateSelect: Constants.DATE_SELECT_TODAY,
  isLoading: false,
  isSubmitting: false,
  selectedDate: Moment().format('YYYY-MM-DD'),
  sort: [],
}

type AllActions = Redux.Action &
                  Request.SuccessAction &
                  DateSelector.DatedInformationAction &
                  Sortable.SortAction &
                  DateSelector.SelectDateRangeAction &
                  IsActive.FilterActionObject &
                  Types.SelectDateAction &
                  App.UrlParsedAction<{selectedDate: Types.SelectedDate}> &
                  Router.OnEnterAction<{dateSelect: Types.SelectedDate}>

export const viewReducer = (sourceReducer: any) =>
  (state: Types.NewsbriefCountViewState = emptyViewState, action: AllActions) => {
  const sourceState = sourceReducer(state, action)
  switch (action.type) {
    case Request.requestConstant(Constants.RESUBMIT_ISSUE):
      return {
        ...sourceState,
        isSubmitting: true,
      }
    case Request.successConstant(Constants.RESUBMIT_ISSUE):
      return {
        ...sourceState,
        isSubmitting: false,
      }
    case Request.requestConstant(Constants.CANCEL_ISSUE):
      return {
        ...sourceState,
        isSubmitting: true,
      }
    case Request.successConstant(Constants.CANCEL_ISSUE):
    case Request.errorConstant(Constants.CANCEL_ISSUE):
      return {
        ...sourceState,
        isSubmitting: false,
      }
      case IsActive.filterStatusConstant(Constants.CHANGE_DATE_SELECT):
      return {
        ...sourceState,
        dateSelect: action.filter,
      }
    case App.URL_PARSED:
      return {
        ...state,
        selectedDate: action.params.selectedDate || state.selectedDate,
      }
    case Constants.NEWSLETTER_COUNTS_UPDATE_SELECTED_DATE:
      return {
        ...state,
        selectedDate: action.date,
      }
    case Router.ON_ENTER:
      if (!Object.keys(action.urlParams).length) {
        return {
          ...state,
        }
      } else if (action.urlParams.dateSelect === Constants.DATE_SELECT_YESTERDAY_MODE) {
        return {
          ...state,
          dateSelect: Constants.DATE_SELECT_YESTERDAY,
        }
      } else if (action.urlParams.dateSelect === Constants.DATE_SELECT_LASTWEEK_MODE) {
        return {
          ...state,
          dateSelect: Constants.DATE_SELECT_LASTWEEK,
        }
      } else if (action.urlParams.dateSelect === Constants.DATE_SELECT_TODAY_MODE) {
        return {
          ...state,
          dateSelect: Constants.DATE_SELECT_TODAY,
        }
      } else {
        return {
          ...state,
          dateSelect: Constants.DATE_SELECT_CUSTOM,
        }
      }
    default:
      return sourceState
  }
}

const normalizeTypes: Sortable.TypeNormalizer<Types.NewsbriefCount> =
  (payload: Sortable.SortableData<Types.NewsbriefCount>):
  Sortable.SortableData<Types.NewsbriefCount> => {
  return payload.map((lp: Types.NewsbriefCount) => ({
    ...lp,
    cutoff_datetime: lp.cutoff ? Moment(lp.cutoff) : null,
    send_at_datetime: lp.send_at ? Moment(lp.send_at) : null,
  }))
}

const reducerEvent: Sortable.ReducerEvent<Types.NewsbriefCount> = {
  defaultSort: {field: 'identifier', dir: 'asc'},
  normalizer: normalizeTypes,
  requestEvent: Constants.FETCH_NEWSBRIEF_COUNTS,
}

export const reducer = Redux.combineReducers({
  data: Sortable.stateReducer(reducerEvent),
  view: viewReducer(Sortable.viewReducer(reducerEvent)),
})



// WEBPACK FOOTER //
// ./src/pages/newsbrief-counts/reducer.ts